export async function doFetch<TResponse = unknown>(
    url: string,
    init?: RequestInit | undefined
): Promise<FetchResult<TResponse>> {
    let ok = false;
    let data: TResponse | undefined = undefined;
    let error: ErrorResponse | undefined = undefined;

    try {
        const response = await fetch(url, init);
        ok = response.ok;

        const text = await response.text();
        const hasBody = text.length > 0;

        if (hasBody) {
            try {
                const json = JSON.parse(text);
                if (isErrorResponse(json)) {
                    error = json;
                } else {
                    data = json;
                }
            } catch (ex) {
                ok = false;
                error = {
                    code: -1,
                    httpCode: response.status,
                    message: ex!.toString(),
                };
            }
        }
        // No body + ok → success with no data
        // No body + !ok → ok is already false, nothing to parse
    } catch (ex2) {
        ok = false;
        error = { code: -1, httpCode: -1, message: ex2!.toString() };
    }

    return {
        ok,
        data,
        error,
        errorString:
            error && `Error: ${error.message} (${error.code}) (HTTP ${error.httpCode})`,
    };
}

export function isErrorResponse(response: any) {
    return "code" in response && "message" in response && "httpCode" in response;
}

export interface FetchResult<T>{
    data?: T
    error?: ErrorResponse
    errorString?: string
    ok: boolean,
}

export interface ErrorResponse {
    code: number;
    message: string;
    httpCode: number;
}

export interface LimitErrorResponse extends ErrorResponse {
    limitName: string
    limitValue: number
    nextLimitValue: number
    currentProductId: string
    nextProductId: string
}